module.exports = __webpack_public_path__ + "img/chat.0efd58f0.svg";